module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.env && _vm.env.mode && _vm.env.mode != 'production') ? _c('div', {
    staticClass: "aviso2"
  }, [_vm._v("\n    Ambiente de Teste\n  ")]) : _vm._e(), _vm._v(" "), _c('b-navbar', {
    staticClass: "header1",
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "light",
      "align": "center",
      "fixed": "top"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#",
      "title": ':: ' + _vm.usuario.logged.point.nome + '\n:: ' + _vm.usuario.logged.nome
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.cliente.logged.url_logo,
      "alt": "Kitten",
      "width": "120"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "align-content-center flex-wrap",
    staticStyle: {
      "font-size": "7pt"
    }
  }, [(_vm.sub_domain == 'empresa') ? _c('span', [_vm._v("Area da Empresa")]) : _vm._e(), _vm._v(" "), (_vm.sub_domain == 'credenciada') ? _c('span', [_vm._v("Area da Credenciada")]) : _vm._e(), _vm._v(" "), (_vm.sub_domain == 'parceiro') ? _c('span', [_vm._v("Area do Parceiro")]) : _vm._e()])]), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "nav-collapse",
      "type": "dark"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "nav-collapse",
      "is-nav": ""
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "transparent",
      "text-color": "#fff",
      "unique-opened": "",
      "active-text-color": "#fff"
    }
  }, [_vm._l((_vm.usuario.menu), function(menu, i) {
    return [(menu.sub_menu.length == 0) ? _c('el-menu-item', {
      key: i,
      class: menu.class + (menu.rota == _vm.$route.path ? ' is-active' : ''),
      attrs: {
        "index": i.toString(),
        "default-active": +(menu.rota == _vm.$route.path ? menu.rota : ''),
        "exact": ""
      },
      on: {
        "click": function($event) {
          return _vm.toRoute({
            path: menu.rota
          })
        }
      }
    }, [_c('i', {
      class: menu.icon
    }), _vm._v("\n            " + _vm._s(menu.descricao) + " \n            "), (menu.badge && menu.badge > 0) ? _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "danger"
      }
    }, [_vm._v(_vm._s(menu.badge))]) : _vm._e()], 1) : _c('el-submenu', {
      key: i,
      class: menu.class,
      attrs: {
        "index": i.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: menu.icon
    }), _vm._v("\n               " + _vm._s(menu.descricao) + "\n            ")]), _vm._v(" "), _vm._l((menu.sub_menu), function(sub_menu, j) {
      return (_vm.isSubMenuVisible(sub_menu)) ? _c('el-menu-item', {
        key: i + j,
        staticClass: "sub_menu",
        attrs: {
          "index": i.toString() + '-' + j.toString()
        },
        on: {
          "click": function($event) {
            return _vm.toRoute({
              path: sub_menu.rota
            })
          }
        }
      }, [_c('i', {
        class: sub_menu.icon
      }), _vm._v("\n              " + _vm._s(sub_menu.descricao) + "\n            ")]) : _vm._e()
    })], 2)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e21fbb7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/menu/header.v2.vue
// module id = 1565
// module chunks = 45